import React from "react";
import { useSelector } from "react-redux";
import Layout from "../layouts/GeneralLayout";
import FeedBackScreen from "../screens/Info/FeedBackScreen";

const Mobilehome = () => {
  return (
    <Layout>
      <FeedBackScreen baseUrl={"/mobile"} />
    </Layout>
  );
};

export default Mobilehome;
